// /labs/genui — REDIRECT, not a ported page. Per the task brief: the GenUI
// lab chat (lab-chat-view.tsx's GenUIChat) merged into the main chat surface
// months ago (see MEMORY.md's "the merge is DONE" note) — GenUIChat IS what
// renders at '/' now (routes/chat-shell.tsx + routes/index.tsx). The old
// apps/web app/labs/genui/page.tsx (an async server component doing
// `getEffectiveUserId() -> redirect if signed out -> <GenUIChat/>`) has no
// reason to exist as a distinct page anymore, so this route just redirects
// straight to '/' instead of re-mounting a second GenUIChat instance (which
// would violate the single-shared-instance invariant chat-shell.tsx exists
// to protect). Kept under `_authed` — same scoping as the placeholder this
// replaces (routes/agents.tsx). Registered from routes/agents.tsx.
import { createRoute, redirect } from '@tanstack/react-router';
import { authedRoute } from './guards';

export const labsGenuiRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/labs/genui',
  beforeLoad: () => {
    throw redirect({ href: '/' });
  },
});
